import { useLocale } from "@utils/hooks/useLocale";
import moment from "moment-timezone";
import { useCallback } from "react";
import { usePlanCreatorContext } from "../PlanCreatorContext";
import { IWeekProps } from "./Week.props";
import { ALLOW_WEEKDAY_PLANS } from "../../../config";

export const useWeekControl = (props: IWeekProps) => {
  // 0 - Sunday
  const { locale } = useLocale();
  const weekDays = moment.localeData(locale).weekdaysShort();

  const {
    disabled,
    selectedDays,
    planDays,
    selectDay,
    updateCurrentDayByDayIndex,
  } = usePlanCreatorContext();

  const isSelected = useCallback((dayIndex: number): boolean => {
    if (!ALLOW_WEEKDAY_PLANS) return false;
    return (selectedDays.indexOf(`${dayIndex}`) > -1); // || (!!exists);
  }, [planDays, selectedDays]);

  const isAlreadySelected = useCallback((dayIndex: number): boolean => {
    if (planDays === undefined) return false;
    return planDays.findIndex(d => d.day === `${dayIndex}`) > -1;
  }, [planDays]);

  const onSelectWeekDay = (dayIndex: string, multiple: boolean) => {
    if (!ALLOW_WEEKDAY_PLANS) return;
    selectDay(dayIndex, multiple);
    updateCurrentDayByDayIndex(dayIndex);
  }

  return {
    weekDays,
    disabled,
    selectedDays,
    isSelected,
    //selectDay,
    isAlreadySelected,
    onSelectWeekDay,
  };
};
